import React from "react"

import { NO, YES, NONE, UNLIMITED, VALUE } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"


import { MtPackage } from "server/models"

import TableSelect from "../components/select"
import { styleOffset } from "./index"

const Cc = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "complianceCaseAccess",
            header: lang.complianceCaseAccess,
            formatter: (packg: MtPackage) => {
                const { ccModuleAccess } = packg.settingsParsed
                return lang[ccModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[ccModuleAccess]}
                        label={lang.complianceCaseAccess}
                        property={{ ccModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "accountComplianceSets",
            header: lang.accountComplianceSets,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccAccountComplianceSets, ccAccountComplianceSetsValue } = packg.settingsParsed
                if (ccAccountComplianceSets === NONE) return lang.none
                if (ccAccountComplianceSets === VALUE) return ccAccountComplianceSetsValue
                if (ccAccountComplianceSets === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccAccountComplianceSets, ccAccountComplianceSetsValue } = packg.settingsParsed
                let title = ""
                if (ccAccountComplianceSets === NONE) title = lang.none
                if (ccAccountComplianceSets === VALUE) title = ccAccountComplianceSetsValue.toString()
                if (ccAccountComplianceSets === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.accountComplianceSets}
                        property={{ ccAccountComplianceSets }}
                        propertyValue={{ ccAccountComplianceSetsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "libraryComplianceSets",
            header: lang.libraryComplianceSets,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccLibraryComplianceSets, ccLibraryComplianceSetsValue } = packg.settingsParsed
                if (ccLibraryComplianceSets === NONE) return lang.none
                if (ccLibraryComplianceSets === VALUE) return ccLibraryComplianceSetsValue
                if (ccLibraryComplianceSets === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccLibraryComplianceSets, ccLibraryComplianceSetsValue } = packg.settingsParsed
                let title = ""
                if (ccLibraryComplianceSets === NONE) title = lang.none
                if (ccLibraryComplianceSets === VALUE) title = ccLibraryComplianceSetsValue.toString()
                if (ccLibraryComplianceSets === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.libraryComplianceSets}
                        property={{ ccLibraryComplianceSets }}
                        propertyValue={{ ccLibraryComplianceSetsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "compliantItemsPerSet",
            header: lang.compliantItemsPerSet,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccCompliantItems, ccCompliantItemsValue } = packg.settingsParsed
                if (ccCompliantItems === NONE) return lang.none
                if (ccCompliantItems === VALUE) return ccCompliantItemsValue
                if (ccCompliantItems === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccCompliantItems, ccCompliantItemsValue } = packg.settingsParsed
                let title = ""
                if (ccCompliantItems === NONE) title = lang.none
                if (ccCompliantItems === VALUE) title = ccCompliantItemsValue.toString()
                if (ccCompliantItems === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.compliantItemsPerSet}
                        property={{ ccCompliantItems }}
                        propertyValue={{ ccCompliantItemsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "projectCompliantItemsPerSet",
            header: lang.projectCompliantItemsPerSet,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccProjectCompliantItems, ccProjectCompliantItemsValue } = packg.settingsParsed
                if (ccProjectCompliantItems === NONE) return lang.none
                if (ccProjectCompliantItems === VALUE) return ccProjectCompliantItemsValue
                if (ccProjectCompliantItems === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccProjectCompliantItems, ccProjectCompliantItemsValue } = packg.settingsParsed
                let title = ""
                if (ccProjectCompliantItems === NONE) title = lang.none
                if (ccProjectCompliantItems === VALUE) title = ccProjectCompliantItemsValue.toString()
                if (ccProjectCompliantItems === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.projectCompliantItemsPerSet}
                        property={{ ccProjectCompliantItems }}
                        propertyValue={{ ccProjectCompliantItemsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "responseModuleAccess",
            header: lang.responseModuleAccess,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccResponseModuleAccess } = packg.settingsParsed
                return lang[ccResponseModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccResponseModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[ccResponseModuleAccess]}
                        label={lang.responseModuleAccess}
                        property={{ ccResponseModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "approvalLevelsAccess",
            header: lang.approvalLevelsAccess,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccApprovalModuleAccess } = packg.settingsParsed
                return lang[ccApprovalModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccApprovalModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[ccApprovalModuleAccess]}
                        label={lang.approvalLevelsAccess}
                        property={{ ccApprovalModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "requirementsModuleAccess",
            header: lang.requirementsModuleAccess,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccRequirementsModuleAccess } = packg.settingsParsed
                return lang[ccRequirementsModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccRequirementsModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[ccRequirementsModuleAccess]}
                        label={lang.requirementsModuleAccess}
                        property={{ ccRequirementsModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "requirements",
            header: lang.requirements,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { ccRequirements, ccRequirementsValue } = packg.settingsParsed
                if (ccRequirements === NONE) return lang.none
                if (ccRequirements === VALUE) return ccRequirementsValue
                if (ccRequirements === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { ccRequirements, ccRequirementsValue } = packg.settingsParsed
                let title = ""
                if (ccRequirements === NONE) title = lang.none
                if (ccRequirements === VALUE) title = ccRequirementsValue.toString()
                if (ccRequirements === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.projectCompliantItemsPerSet}
                        property={{ ccRequirements }}
                        propertyValue={{ ccRequirementsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Cc
